import type { State } from '@/reducers/types';
import { AppUser } from '@/types';
import { createSlice } from '@reduxjs/toolkit';
import { getUserInfo, logout } from './actions';

export interface AuthState {
  user: AppUser | null;
}

const initialState: AuthState = {
  user: null,
};

export const { name, reducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        if (action.payload) {
          state.user = action.payload;
        }
      });
  },
});

export const selectAuthUser = (state: State) => state[name].user;
export const selectAuthUserId = (state: State) => state[name].user?.id || null;
